import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { TileGroup, Tile } from '../../../ui';

export const LatestNews = () => {
  return (
    <Container>
      <Typography variant='h3' align='center' mt={8}>
        Read the Latest News
      </Typography>
      <TileGroup type='news' py={3}>
        <Tile
          title='AHRQ QI Presentations at the 2025 AcademyHealth Annual Research Meeting.'
          description={`Presentations by AHRQ QI Program Staff at the 2025 AcademyHealth Annual Research Conference.`}
          label='Announcement'
          date='June 7, 2025'
          to='/resources/presentations'
          promote
        />
        <Tile
          title='Minor release of v2024 for SAS QI v2024.0.2 and CloudQI v2024.0.3 Software.'
          description={`This is a minor release of AHRQ v2024 Software to address a user reported issue with the PQE module. Details are in the Software Release Notes.`}
          label='Software'
          date='June 6, 2025'
          to='/news#software-release-2026-06-06'
          promote
        />
        <Tile
          title='AHRQ Listening Session on Opportunities to Update the Patient Safety Indicators (PSIs).'
          description={`AHRQ held a listening session to review interim findings from a gap analysis to identify opportunities for future measurement, including opportunities to expand PSIs to new care settings and populations.`}
          label='Announcement'
          date='May 7, 2025'
          to='/announcements/2025/05'
        />
      </TileGroup>
      <Box mb={8} textAlign='center'>
        <Typography variant='h5' color='primary'>
          <Link to='/news'>
            See all news <ChevronRightIcon />
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};
